// extracted by mini-css-extract-plugin
export default {"container":"Va6oZkc"};